const LoadingState = ({}) => {
  return (
    <div className="animate-pulse shadow-md aspect-[3] bg-gray-300"/>


  );
};


export default LoadingState;